var render, staticRenderFns
import script from "./baseGarante.vue?vue&type=script&lang=js&"
export * from "./baseGarante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9e928ba')) {
      api.createRecord('a9e928ba', component.options)
    } else {
      api.reload('a9e928ba', component.options)
    }
    
  }
}
component.options.__file = "src/components/Flujo/Formularios/Garante/baseGarante.vue"
export default component.exports